// Map of the original, casual social media selfies from assets.
// These match the real-life aesthetic of the app perfectly.
export const FEMALE_AVATARS = [
  "/landing/profiles/1.jpeg",
  "/landing/profiles/2.jpg",
  "/landing/profiles/3.jpeg",
  "/landing/profiles/4.jpeg",
];

export const MALE_AVATARS = [
  "/landing/profiles/5.jpeg",
  "/landing/profiles/6.jpeg",
  "/landing/profiles/7.jpeg",
  "/landing/profiles/8.jpg",
  "/landing/profiles/9.jpg",
];

/**
 * Automatically infers gender from a name or username string to match avatars correctly.
 */
export function getGenderByName(name: string): "male" | "female" {
  const normalized = name.toLowerCase();

  const femaleKeywords = [
    "maya",
    "jess",
    "sofia",
    "sophia",
    "amanda",
    "clara",
    "emily",
    "kate",
    "rose",
    "hannah",
  ];

  if (femaleKeywords.some((keyword) => normalized.includes(keyword))) {
    return "female";
  }

  return "male";
}

/**
 * Resolves a unique profile image URL matching a target gender and index.
 * If gender is unspecified or "any", it alternates between female and male pools.
 */
export function getAvatarUrl(
  gender: "male" | "female" | "any" | string | null | undefined,
  index: number,
): string {
  if (!gender || gender === "any") {
    // Alternate pools based on index
    const pool = index % 2 === 0 ? FEMALE_AVATARS : MALE_AVATARS;
    const poolIndex = Math.floor(index / 2);
    return pool[poolIndex % pool.length];
  }

  const isMale =
    gender === "male" ||
    (typeof gender === "string" && gender.toLowerCase() === "male");
  const pool = isMale ? MALE_AVATARS : FEMALE_AVATARS;
  return pool[Math.abs(index) % pool.length];
}
